module.exports = __webpack_public_path__ + "img/qrcode_xhs.d379cd43.jpg";